import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Checkout/TransportService/transportService"
    ).then((module) => ({ default: module.TransportService }))
);
